var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#BF1E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14307 5.18848V11H6.71973V5.18848H8.14307ZM6.62305 3.66846C6.62305 3.45719 6.69466 3.28174 6.83789 3.14209C6.9847 3.00244 7.18164 2.93262 7.42871 2.93262C7.67578 2.93262 7.87093 3.00244 8.01416 3.14209C8.16097 3.28174 8.23438 3.45719 8.23438 3.66846C8.23438 3.87614 8.16097 4.0498 8.01416 4.18945C7.87093 4.3291 7.67578 4.39893 7.42871 4.39893C7.18164 4.39893 6.9847 4.3291 6.83789 4.18945C6.69466 4.0498 6.62305 3.87614 6.62305 3.66846Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInfo);
export default __webpack_public_path__ + "static/media/active-info.575be0d3f236000b242641c035e197e0.svg";
export { ForwardRef as ReactComponent };